// Shared types and enums for Alert Manager
export var SOURCE;
(function (SOURCE) {
    SOURCE["GRAFANA"] = "grafana";
    SOURCE["WEBSOCKET"] = "websocket";
    SOURCE["API"] = "api";
    SOURCE["WEBHOOK"] = "webhook";
    SOURCE["DRUID"] = "druid";
    SOURCE["ANYWHERE"] = "anywhere";
})(SOURCE || (SOURCE = {}));
export var ENVIRONMENT;
(function (ENVIRONMENT) {
    ENVIRONMENT["PRODUCTION"] = "production";
    ENVIRONMENT["STAGING"] = "staging";
    ENVIRONMENT["DEVELOPMENT"] = "develop";
})(ENVIRONMENT || (ENVIRONMENT = {}));
export var SEVERITY;
(function (SEVERITY) {
    SEVERITY["CRITICAL"] = "critical";
    SEVERITY["WARNING"] = "warning";
    SEVERITY["HIGH"] = "high";
    SEVERITY["INFO"] = "info";
})(SEVERITY || (SEVERITY = {}));
export var STATUS;
(function (STATUS) {
    STATUS["ONGOING"] = "ongoing";
    STATUS["RESOLVED"] = "resolved";
})(STATUS || (STATUS = {}));
export var ACKNOWLEDGED_STATUS;
(function (ACKNOWLEDGED_STATUS) {
    ACKNOWLEDGED_STATUS["UNACKNOWLEDGED"] = "unacknowledged";
    ACKNOWLEDGED_STATUS["ACKNOWLEDGED"] = "acknowledged";
})(ACKNOWLEDGED_STATUS || (ACKNOWLEDGED_STATUS = {}));
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["USER"] = "user";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=types.js.map